import { faGem, faTrophy, faBolt, faSeedling } from "@fortawesome/free-solid-svg-icons";

/**
 * Retorna tier, ícone, cor e progresso para um total de pontos.
 */
export function getUserLevel(pts) {
  if (pts >= 700) return { tier: "Elite",    icon: faGem,      color: "#9fe1cb", next: null, progress: 100 };
  if (pts >= 300) return { tier: "Avançado", icon: faTrophy,   color: "#ef9f27", next: 700,  progress: Math.round(((pts - 300) / 400) * 100) };
  if (pts >= 100) return { tier: "Regular",  icon: faBolt,     color: "#63b3ed", next: 300,  progress: Math.round(((pts - 100) / 200) * 100) };
  return               { tier: "Iniciante", icon: faSeedling, color: "#9fe1cb", next: 100,  progress: Math.round((pts / 100) * 100) };
}
